module.exports = __webpack_public_path__ + "static/media/audio-books.4bb2df02.mp3";